import React from 'react'
import { IColumnType } from '../../../../types/project'

interface ExportColumnsModalProps {
  show: boolean
  onClose: () => void
  selectedExportColumns: IColumnType
  setSelectedExportColumns: (columns: IColumnType) => void
  handleSelectAllColumns: () => void
  handleDeselectAllColumns: () => void
  onExport: () => void
}

const columnDisplayNames: { [key: string]: string } = {
  number: 'Lp.',
  stage: 'Etap',
  name: 'Nazwa',
  type: 'Typ',
  price: 'Cena (PLN)',
  quantity: 'Ilość',
  unit: 'Jednostka',
  value: 'Wartość (PLN)',
  url: 'URL',
  image: 'Zdjęcie',
  dimensions: 'Wymiary/Pojemność',
  description: 'Opis',
  status: 'Status',
  deliveryCost: 'Koszt dostawy',
  discountPercentage: 'Procent rabatu',
  marginPercentage: 'Procent marży',
  vatPercentage: 'Procent VAT',
  category: 'Kategoria',
  supplier: 'Dostawca',
  catalogNumber: 'Nr kat.'
}

export const ExportColumnsModal: React.FC<ExportColumnsModalProps> = ({
  show,
  onClose,
  selectedExportColumns,
  setSelectedExportColumns,
  handleSelectAllColumns,
  handleDeselectAllColumns,
  onExport
}) => {
  if (!show) return null

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1050,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden'
    }}
    >
      <div style={{
        width: '500px',
        maxWidth: '90%',
        margin: 'auto',
        backgroundColor: 'white',
        borderRadius: '5px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
      }}
      >
        <div className='modal-header'>
          <h5 className='modal-title'>Wybierz kolumny do eksportu</h5>
          <button type='button' className='close' onClick={onClose}>
            <span>&times;</span>
          </button>
        </div>
        <div className='modal-body p-3'>
          <div className='d-flex justify-content-between mb-3'>
            <button
              className={`
                      tw-text-center tw-font-semibold tw-rounded-md tw-shadow-lg tw-transition-colors
                      tw-text-teal
                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-white hover:tw-bg-opacity-90 focus:tw-bg-white
                    `}
              onClick={handleSelectAllColumns}
            >
              Zaznacz wszystkie
            </button>

            <button
              className={`
                      tw-text-center tw-font-semibold tw-rounded-md tw-shadow-lg tw-transition-colors
                      tw-text-teal
                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-white hover:tw-bg-opacity-90 focus:tw-bg-white
                    `}
              onClick={handleDeselectAllColumns}
            >
              Odznacz wszystkie
            </button>
          </div>

          <div className='row'>
            {Object.keys(selectedExportColumns).map(column => (
              <div className='col-md-6 mb-2' key={column}>
                <div className='form-check'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    id={`column-${column}`}
                    checked={selectedExportColumns[column]}
                    onChange={(e) => setSelectedExportColumns({
                      ...selectedExportColumns,
                      [column]: e.target.checked
                    })}
                  />
                  <label className='form-check-label' htmlFor={`column-${column}`}>
                    {columnDisplayNames[column] || column}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className='modal-footer'>
          <button
            className={`
                      tw-text-center tw-font-semibold tw-rounded-md tw-shadow-lg tw-transition-colors
                      tw-text-teal
                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-white hover:tw-bg-opacity-90 focus:tw-bg-white
                    `}
            onClick={onClose}
          >
            Anuluj
          </button>

          <button
            className={`
                      tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                      tw-text-white
                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                    `}
            onClick={onExport}
            disabled={Object.values(selectedExportColumns).every(v => !v)}
          >
            Eksportuj
          </button>
        </div>
      </div>
    </div>
  )
}
